import { useLanguage } from "../contexts/LanguageContext";
import myArticlesJa from "../data/articles";
import myArticlesEn from "../data/articles.en";

/**
 * 現在の言語設定に応じた記事データを取得するフック
 */
export const useArticles = () => {
	const { language } = useLanguage();
	return language === 'ja' ? myArticlesJa : myArticlesEn;
};
